import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { ExtractItem } from 'src/utils/extractDescription'
import transactionLabel from 'src/utils/transactionLabel'

import { config } from 'src/config'
import { useAuth } from 'src/hooks/auth'
import { Billet } from 'src/pages/payBillsPayInvoice'
import dateToLine from 'src/utils/dateToLine'
import { documentFormatted } from 'src/utils/documentFormatted'
import toLocaleAmount from 'src/utils/toLocaleAmount'
import { Button } from '../button'
import {
  ButtonWrapper,
  CloseIcon,
  DownloadIcon,
  InfoModal,
  ModalContent,
  ModalHeader,
  Section,
  SectionCPNJ,
  SectionItem,
  SectionPayerName,
  SectionTitle,
} from '../ModalConfirmOperation/styles'

export const Slip: FC<{ data: ExtractItem; closeModal: () => void }> = ({
  data,
  closeModal,
}) => {
  const { user, account } = useAuth()
  const navigate = useNavigate()

  if (!data.type.toLowerCase().includes('slip')) {
    navigate('/extract')
  }

  function printPDF() {
    if (!data) return
    const receiptString = JSON.stringify({ ...data, user })
    localStorage.setItem('temp_receipt_to_print', receiptString)
    window.open(`${config.FRONTEND_URL}/PDF`)
  }

  const response = data.data as Billet
  const label = transactionLabel(data)
  const payerName =
    data.direction === 'out'
      ? user.name
      : response.payment_info.payer_name || 'Desconhecido'
  const payerDocument =
    data.direction === 'out'
      ? user.document
      : response.payment_info.payer_document || 'Desconhecido'
  const bankName = response.barcode_details.bank_name || 'Desconhecido'
  const lineCode = response.barcode_details.digitable_line || 'Não disponível'
  const barCode = response.barcode_details.barcode || 'Não disponível'

  return (
    <>
      <ModalHeader>
        <div>
          <span>{label}</span>
          <button onClick={closeModal}>
            <CloseIcon />
          </button>
        </div>
      </ModalHeader>
      <ModalContent>
        <InfoModal>
          <div>
            <p>R$ {toLocaleAmount(data?.amount)}</p>
          </div>
          <span>{dateToLine(data?.created_at)}</span>
        </InfoModal>
        <Section>
          <SectionTitle>Pagador</SectionTitle>
          <SectionPayerName>
            <span>NOME</span>
            <p>{payerName}</p>
          </SectionPayerName>
          <SectionCPNJ>
            <span>Documento</span>
            <p>{documentFormatted(payerDocument)}</p>
          </SectionCPNJ>
        </Section>
        <Section>
          <SectionTitle>Boleto</SectionTitle>
          <SectionItem>
            <span>Banco</span>
            <p>{bankName}</p>
          </SectionItem>
          <SectionItem>
            <span>Linha Digitável</span>
            <p>{lineCode}</p>
          </SectionItem>
          <SectionItem>
            <span>Código de Barras</span>
            <p>{barCode}</p>
          </SectionItem>
        </Section>
        <ButtonWrapper>
          <Button
            handleFunction={printPDF}
            Icon={DownloadIcon}
            title="Baixar Comprovante"
          />
        </ButtonWrapper>
      </ModalContent>
    </>
  )
}
